module.exports = __webpack_public_path__ + "media/07 nevertheless.28549d3c.mp3";